import type { AnalysisResult } from '../types';

export function findVideoSource(res: AnalysisResult | null, uploadedObjectUrl?: string | null): string | null {
  if (!res) return null;
  const anyRes = res as unknown as Record<string, unknown>;
  const candidates: string[] = [];

  if (typeof anyRes.videoUrl === 'string' && anyRes.videoUrl) candidates.push(anyRes.videoUrl as string);
  if (Array.isArray(anyRes.fileUrls) && (anyRes.fileUrls as unknown as string[]).length) candidates.push((anyRes.fileUrls as unknown as string[])[0]);
  if (Array.isArray(anyRes.files) && (anyRes.files as unknown as { url?: string }[]).length) {
    const f0 = (anyRes.files as unknown as { url?: string }[])[0];
    if (f0?.url) candidates.push(f0.url);
  }
  if (typeof anyRes.file_url === 'string' && anyRes.file_url) candidates.push(anyRes.file_url as string);
  if (typeof anyRes.fileUrl === 'string' && anyRes.fileUrl) candidates.push(anyRes.fileUrl as string);

  const analysisText = String(res.analysis || '');
  const urlVideoRegex = /(https?:\/\/[^\s)"']+?\.(mp4|webm|mov|mkv)(\?[^\s)"']*)?)/i;
  const urlMatch = analysisText.match(urlVideoRegex);
  if (urlMatch && urlMatch[1]) candidates.push(urlMatch[1]);

  const dataVideoRegex = /(data:video\/[a-zA-Z0-9.+-]+;base64,[A-Za-z0-9+/=]+)/;
  const dataMatch = analysisText.match(dataVideoRegex);
  if (dataMatch && dataMatch[1]) candidates.push(dataMatch[1]);

  if (uploadedObjectUrl) candidates.push(uploadedObjectUrl);

  for (const c of candidates) {
    if (typeof c === 'string' && c.trim()) return c.trim();
  }
  return null;
}

export function findAudioSource(res: AnalysisResult | null, uploadedObjectUrl?: string | null): string | null {
  if (!res) return null;
  const anyRes = res as unknown as Record<string, unknown>;
  const candidates: string[] = [];
  if (typeof anyRes.audioUrl === 'string' && anyRes.audioUrl) candidates.push(anyRes.audioUrl as string);
  if (Array.isArray(anyRes.fileUrls) && (anyRes.fileUrls as unknown as string[]).length) candidates.push((anyRes.fileUrls as unknown as string[])[0]);
  if (Array.isArray(anyRes.files) && (anyRes.files as unknown as { url?: string }[]).length) {
    const f0 = (anyRes.files as unknown as { url?: string }[])[0];
    if (f0?.url) candidates.push(f0.url);
  }
  const analysisText = String(res.analysis || '');
  const urlAudioRegex = /(https?:\/\/[^\s)"']+?\.(mp3|wav|m4a|aac)(\?[^\s)"']*)?)/i;
  const urlMatch = analysisText.match(urlAudioRegex);
  if (urlMatch && urlMatch[1]) candidates.push(urlMatch[1]);

  if (uploadedObjectUrl) candidates.push(uploadedObjectUrl);

  for (const c of candidates) {
    if (typeof c === 'string' && c.trim()) return c.trim();
  }
  return null;
}
